import React from 'react';
import { render } from 'react-dom';
import { toast } from 'react-toastify';
import '@babel/polyfill';
import 'react-toastify/dist/ReactToastify.css';
import bugsnag from '@bugsnag/js';
import domready from 'domready';

import LazyLoader from './LazyLoader';
import { loadFile } from '../../functions/deferedFonts';
import getYouTubeLink from '../../functions/ValidateVideoLinks';
import EAP_EXTERNAL from '../../../Tools/Paths/Resources/es6/ExternalCrmModule';
import addJavascriptScriptToHead from './addJavascriptScriptToHead';
import loadFrontCookies from '../../../Tools/Cookies/Resources/es6/loadFrontCookies';

const { host } = window.location;
const devDomains = ['leadsites8.test', 'local.net'];
if (!devDomains.includes(host)) {
	bugsnag('b5d0fcba481dab8d5c063c8737310df1');
}
LazyLoader();

toast.configure();
const ROOTAPP = () => import(/* webpackChunkName: "ROOTAPP" */ '../../index');
const IDX = () => import(/* webpackChunkName: "IdxRetsImport" */ '../../../Tools/Idx/Resources/components/eap-rets');
const ContactPage = () =>
	import(/* webpackChunkName: "ContactPage" */ '../../../Tools/ContactMe/Resources/components/ContactPage');
const SchedulePage = () =>
	import(/* webpackChunkName: "SchedulePage" */ '../../../Tools/ContactMe/Resources/components/SchedulePage');
const ContactShortcode = () =>
	import(/* webpackChunkName: "ContactShortcode" */ '../../../Tools/ContactMe/Resources/components/ContactShortcode');

const FeaturedFarms = () =>
	import(/* webpackChunkName: "FeaturedFarms" */ '../../../Tools/InstaFarm/Resources/components/FeaturedFarms');
const InstaFarm = () =>
	import(/* webpackChunkName: "InstaFarmMain" */ '../../../Tools/InstaFarm/Resources/components/InstafarmV2Front');
const SinglePropertyPage = () =>
	import(/* webpackChunkName: "SinglePropertyPage" */ '../../../Tools/SingleProperty/Resources/components/FrontSingleProperty');
const frontTableLeaseToOwn = () =>
	import(/* webpackChunkName: "frontendLeaseToOwnTable" */ '../../../Tools/Idx/LeaseToOwn/frontendLeaseToOwnTable');
const HvaFront = () =>
	import(/* webpackChunkName: "HvaFrontendForm" */ '../../../Tools/HomeValueTool/Resources/components/HvaFrontendForm');

const HvaWidget = () =>
	import(/* webpackChunkName: "Hva_widget" */ '../../../Tools/HomeValueTool/Resources/components/Hva_widget');
const gmaps = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBTwyBk1AFSk8f6KutyWSqWVCu0dhTKbbA&libraries=places,region=us';

const PrioritizeOffice = () =>
	import(/* webpackChunkName: "PrioritizeOffice" */ '../../../Tools/Idx/Resources/components/backend/PrioritizeOffice');
const UpdateIndividualListing = () =>
	import(
		/* webpackChunkName: "UpdateIndividualListing" */ '../../../Tools/Idx/Resources/components/backend/UpdateIndividualListing'
	);

const AdminDeletion = () =>
	import(/* webpackChunkName: "AdminDeletion" */ '../../../Tools/SettingsPage/AdminSettingPage/components/AdminDeletion');
const EditAFarmPage = () =>
	import(/* webpackChunkName: "EditAFarmPage" */ '../../../Tools/InstaFarm/Resources/components/EditAFarmPage');
const EditAPropertyPage = () =>
	import(/* webpackChunkName: "EditAPropertyPage" */ '../../../Tools/SingleProperty/Resources/components/EditAPropertyPage');
const EditAVendorPage = () =>
	import(/* webpackChunkName: "EditAVendorPage" */ '../../../Tools/VendorApp/Resources/components/EditorInterface');
const SendNotif = () =>
	import(/* webpackChunkName: "SendNotif" */ '../../../Tools/SettingsPage/AdminSettingPage/components/SendNotif');
const OffloadMoreLeads = () =>
	import(/* webpackChunkName: "OffloadMoreLeads" */ '../../../Tools/SettingsPage/AdminSettingPage/components/OffloadMoreLeads');
const AdminInstafarm = () => import(/* webpackChunkName: "AdminInstafarm" */ '../../../Tools/Idx/Classes/ShortcodeFinder/Admin');
const LeadLockLinkBuilder = () =>
	import(/* webpackChunkName: "LeadLockLinkBuilder" */ '../../../Tools/LeadLock/Resources/components/LeadLockButton');
const SocialShareFront = () =>
	import(/* webpackChunkName: "SocialShareFront" */ '../../../Tools/Social/Resources/components/FrontSocialShare');
const SocialShareBack = () => import(/* webpackChunkName: "SocialShareBack" */ '../../../Tools/Social/Resources/js/main');
const TwitterIntegration = () =>
	import(/* webpackChunkName: "SocialIntegtations" */ '../../../Tools/TwitterIntegration/Resources/js/front');
const initSupportHelpArticles = () =>
	import(/* webpackChunkName: "initSupportHelpArticles" */ '../../../Tools/Support/Resources/es6/supportHelpArticles');

const loadgmaps = () => {
	if (document.getElementById('eap_maps_script') === null) {
		addJavascriptScriptToHead(gmaps, 'eap_maps_script');
	}
};

(() => {
	if (typeof window.EAP === 'undefined') {
		window.EAP = {};
	}
	window.EAP.getYoutubeID = getYouTubeLink;
	loadFile([
		'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css',
		'https://fonts.googleapis.com/css?family=Lato:400,400i,700,700i,900,900i|Source+Serif+Pro:400,700|Material+Icons|Open+Sans|Montserrat:400,500,600,700,800,900',
	]);

	domready(() => {
		window.EAP_EXTERNAL = EAP_EXTERNAL;
		EAP_EXTERNAL.run();
		SocialShareFront().then(({ SocialShare }) => {
			SocialShare();
		});
		loadFrontCookies();
		if (typeof eapRetsOptions !== 'undefined') {
			IDX().then(({ Lazy }) => Lazy());
		}
		if (document.getElementById('eapEditorRootApp') !== null) {
			ROOTAPP().then(({ LAZY }) => render(<LAZY />, document.getElementById('eapEditorRootApp')));
		}
		/**
		 * PAGES
		 */
		if (document.getElementById('contact_page_mount') !== null) {
			ContactPage().then(({ Lazy }) => render(<Lazy />, document.getElementById('contact_page_mount')));
		} else if (document.getElementById('schedule_page_mount') !== null) {
			SchedulePage().then(({ Lazy }) => render(<Lazy />, document.getElementById('schedule_page_mount')));
		} else if (document.getElementById('instafarmPageV2')) {
			InstaFarm().then(({ Lazy }) => Lazy());
		} else if (document.getElementById('singlePropertyPage')) {
			SinglePropertyPage().then(({ Lazy }) => Lazy());
		}

		/**
		 * WIDGETS
		 */
		if (document.querySelectorAll('.contact_form_mount').length > 0) {
			ContactShortcode().then(({ Lazy }) => render(<Lazy />, document.querySelector('.contact_form_mount')));
		}
		if (document.getElementById('hva_mount') !== null) {
			loadgmaps();
			const script = document.getElementById('eap_maps_script');
			script.addEventListener('load', () => {
				HvaFront().then(({ Lazy }) => render(<Lazy />, document.getElementById('hva_mount')));
			});
		}
		if (document.getElementById('eap_farms_featured') !== null) {
			FeaturedFarms().then(({ Lazy }) => render(<Lazy />, document.getElementById('eap_farms_featured')));
		}
		if (document.querySelectorAll('.eap_hva_widget').length > 0) {
			loadgmaps();
			const script = document.getElementById('eap_maps_script');
			script.addEventListener('load', () => {
				HvaWidget().then(({ Lazy }) => {
					const hvaWidget = document.querySelectorAll('.eap_hva_widget');
					for (let i = 0; i < hvaWidget.length; i += 1) {
						render(
							<Lazy type={document.querySelectorAll('.eap-homepage-is-golden').length > 0 ? 'golden' : 'theme'} />,
							hvaWidget[i]
						);
						if (document.querySelectorAll('.eap-homepage-is-golden').length === 0) {
							hvaWidget[i].classList.add('hva-shortcode');
						}
					}
				});
			});
		}
		if (document.querySelectorAll('.eap-twitter-widget').length > 0) {
			TwitterIntegration().then(({ Lazy }) => {
				const TwitterWidget = document.querySelectorAll('.eap-twitter-widget');
				for (let i = 0; i < TwitterWidget.length; i += 1) {
					const tweets = TwitterWidget[i].getAttribute('data-tweets');
					render(<Lazy tweets={tweets} />, TwitterWidget[i]);
				}
			});
		}

		/**
		 * Backend Routes
		 */
		if (document.getElementById('UpdateIndividualListing') !== null) {
			UpdateIndividualListing().then(({ Lazy }) => render(<Lazy />, document.getElementById('UpdateIndividualListing')));
		}
		if (document.getElementById('eapPrioritizeOffice') !== null) {
			PrioritizeOffice().then(({ Lazy }) => render(<Lazy />, document.getElementById('eapPrioritizeOffice')));
		}
		if (document.querySelector('.eapHelpButtonModal')) {
			initSupportHelpArticles().then(({ Lazy }) => Lazy());
		}

		if (document.getElementById('eapAdminSettingsDelete') !== null) {
			AdminDeletion().then(({ Lazy }) => render(<Lazy />, document.getElementById('eapAdminSettingsDelete')));
		} else if (document.querySelector('body.post-type-eap-areas') !== null) {
			EditAFarmPage().then(({ Lazy }) => Lazy());
		} else if (document.querySelector('body.post-type-properties') !== null) {
			EditAPropertyPage().then(({ Lazy }) => Lazy());
		} else if (document.querySelector('body.post-type-vendors') !== null) {
			EditAVendorPage().then(({ Lazy }) => Lazy());
		} else if (document.getElementById('eap_internal_shortcode_builder_searcher') !== null) {
			AdminInstafarm().then(({ LAZY }) => render(<LAZY />, document.getElementById('eap_internal_shortcode_builder_searcher')));
		} else if (document.getElementById('leadLockBuilderButton') !== null) {
			LeadLockLinkBuilder().then(({ LAZY }) => render(<LAZY />, document.getElementById('leadLockBuilderButton')));
		} else if (document.getElementById('weAreOnTheAdminSocialSharePage') !== null) {
			SocialShareBack();
		}
		if (document.getElementById('eapAdminSettingsSendNotif') !== null) {
			SendNotif().then(({ Lazy }) => render(<Lazy />, document.getElementById('eapAdminSettingsSendNotif')));
		}
		if (document.getElementById('rootForLeadOffloaderMount') !== null) {
			OffloadMoreLeads().then(({ Lazy }) => render(<Lazy />, document.getElementById('rootForLeadOffloaderMount')));
		}
		if (window.leasePricing) {
			frontTableLeaseToOwn().then(({ Lazy }) => Lazy());
		}
	});
})();
